<template>
    <footer class="footer">

        <!-- ===== Start of Footer Information & Links Section ===== -->
        <div class="footer-info ptb100">
            <div class="row">
                <!-- 1st Footer Column -->
                <div class="col-md-4 col-sm-6 col-xs-6 footer-about">

                    <!-- Your Logo Here -->
                    <a @click="$router.push('/')">
                        <img :src="asset('/img/logo.svg')" alt="">
                    </a>

                    <!-- Info -->
                    <ul class="footer-mails nopadding mt20">
                        <li>
                            <a title="Email our billing team" href="mailto:billing@cryohost.co.zw">
                                <i class="far fa-envelope"></i>&nbsp; {{ emails.billing }}
                            </a>
                        </li>
                        <li>
                            <a title="Email our support team" href="mailto:support@cryohost.co.zw">
                                <i class="far fa-envelope"></i>&nbsp; {{ emails.support }}
                            </a>
                        </li>
                        <li>
                            <a title="Email our legal team" href="mailto:legal@cryohost.co.zw">
                                <i class="far fa-envelope"></i>&nbsp; {{ emails.legal}}
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- 2nd Footer Column -->
                <div class="col-md-4 col-sm-6 col-xs-6 footer-links">
                    <h4>useful links</h4>

                    <!-- Links -->
                    <ul class="nopadding mt20">
                        <li><a href="https://my.cryo.host/supporttickets.php">Customer Support</a></li>
                        <li><a href="https://my.cryo.host/">
                            Customer Area</a>
                        </li>
                        <li>
                            <router-link tag="a" to="/legal/tos" exact>
                                Terms of Service
                            </router-link>
                        </li>
                        <li>
                            <router-link tag="a" to="/legal/privacy-policy" exact>
                                Privacy Policy
                            </router-link>
                        </li>
                    </ul>
                </div>


                <!-- 2nd Footer Column -->
                <div class="col-md-4 col-sm-6 col-xs-6 footer-links">
                    <h4>Hosting Services</h4>

                    <!-- Links -->
                    <ul class="nopadding mt20">
                        <li>
                            <router-link tag="a" to="/hosting/shared" exact>
                                Shared Hosting
                            </router-link>
                        </li>
                        <li>
                            <router-link tag="a" to="/hosting/vps" exact>
                                VPS Hosting
                            </router-link>
                        </li>

                    </ul>
                </div>

            </div>
        </div>
        <!-- ===== End of Footer Information & Links Section ===== -->


        <!-- ===== Start of Footer Copyright Section ===== -->
        <div class="copyright ptb20">
            <div class="row bottom-footer">

                <div class="col-md-6 col-sm-6 col-xs-12 credits">
                    cryohost. &copy; {{ new Date().getFullYear() }}
                    <br><span>Made with <span
                        class="love">&#10084;</span> by <a
                        href="https://alcra.co" class="agency-link">alcra.</a></span>
                </div>

                <div class="col-md-6 col-sm-6 col-xs-12 social-links">
                    <!-- Start of Social Media Buttons -->
                    <ul class="social-btns list-inline text-right">
                        <!-- Social Media -->
                        <li>
                            <a href="https://fb.me/cryohostzw" target="_blank" class="social-btn-roll facebook">
                                <i class="social-btn-roll-icon fab fa-facebook"></i>
                            </a>
                        </li>

                        <!-- Social Media -->
                        <li>
                            <a href="https://twitter.com/cryohostzw" target="_blank" class="social-btn-roll twitter">
                                <i class="social-btn-roll-icon fab fa-twitter"></i>
                            </a>
                        </li>

                        <!-- Social Media -->
                        <li>
                            <a href="https://linkedin.com/cryohostzw" target="_blank" class="social-btn-roll linkedin">
                                <i class="social-btn-roll-icon fab fa-linkedin"></i>
                            </a>
                        </li>

                    </ul>
                    <!-- End of Social Media Buttons -->
                </div>

            </div>
        </div>
        <!-- ===== End of Footer Copyright Section ===== -->

    </footer>
</template>

<script>
    import Config from "../../config";

    export default {
        name: "FooterComponent",
        data: function () {
            return {
                emails: Config.emails
            };
        }
    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
    }

    .love {
        color: #ff3393 !important;
    }

    footer {
        a {
            color: lighten(#0e324d, 20)
        }
    }

    footer .footer-info {
        background: #f6f6f6;
    }

    footer .footer-info > div {
        position: relative;
        z-index: 3;
    }

    footer .footer-info .footer-about {
        font-size: 14px;
    }

    footer .footer-info p, footer .footer-info a, footer .footer-info ul li, footer .footer-info span {
        font-size: 14px;
        line-height: 22px;
        color: #6a7e8e;
    }

    footer .footer-info .footer-about img {
        height: 26px;
    }

    footer .footer-info .footer-about > ul > li {
        padding-bottom: 10px;
    }

    footer .footer-info .footer-links ul li {
        padding-bottom: 10px;
    }

    footer .footer-info h4 {
        color: #6a7e8e;
        text-transform: capitalize;
        padding-bottom: 0;
    }

    footer .copyright {
        background: #f6f6f6;
        border-top: 1px solid #e3e3e3;
        padding-left: 20px;
        padding-right: 20px;
    }

    .agency-link {
        text-transform: lowercase !important;
    }

    footer .copyright span, footer .copyright a {
        font-family: montserrat, sans-serif;
        font-weight: 600;
        text-transform: capitalize;
    }

    footer .copyright span {
        color: #6a7e8e;
        line-height: 40px;
    }

    .footer-info .col-md-4 {
        box-sizing: border-box;
        margin: 0;
        vertical-align: text-top;
    }


    .col-md-6.col-sm-6.col-xs-12 {
        display: inline-block;
        box-sizing: border-box;
        width: 40%;
    }

    .footer-info > .row {
        padding: 0 20px;
    }

    @media screen and (max-width: 768px) {
        .footer-info {
            &.ptb100 {
                padding-top: 50px;
                padding-bottom: 10px;
            }
        }

        .copyright {
            .bottom-footer {

                & > div {
                    text-align: left;

                    .social-btns {
                        margin-top: 15px;
                        text-align: left !important;
                    }
                }

                .social-links {
                    width: 100%;
                    display: block;
                }

                div:first-child {
                    display: block;
                    width: 100%;

                    b {
                        display: none;
                    }

                    & > span {
                        display: block;
                    }
                }
            }
        }
    }
</style>